// extracted by mini-css-extract-plugin
export default {"steps":"StepsCircle_steps__3hHV2","steps__item":"StepsCircle_steps__item__esgfX"};